import { useLocation, useHistory } from "react-router-dom";

export const useHideUpdateCartModal = (): (() => void) => {
  const location = useLocation();
  const history = useHistory();

  if (history.length > 1) {
    return () => history.goBack();
  }
  return () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("product");
    searchParams.delete("findByToken");
    searchParams.delete("updateQuantityOnChange");
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };
};
